import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import Breadcrumb from "../../../../App/Components/Navigation/Breadcrumbs/Breadcrumbs";
import { Button, Dialog, FormHelperText, Grid } from "@mui/material";
import { useLocation, Redirect } from "react-router-dom";
import DetailedTableCell from "./DetailedTableCell";
import DetailedAddModal from "./DetailedAddModal";
import { callAPI } from "../../../../App/Helpers/callApi";
import { deleteFeaturedGroup } from "../../FeaturedGroupsService";
import Signifier from "../../../../App/Components/Signifier/Signifier";
import ConfirmationModal from "../../../../App/Components/Modals/ConfirmationModal";
import { basicSort } from "../../../../App/Helpers/BasicSort";
import { useSelector } from "react-redux";
import { selectCareersClientValue } from "../../../../App/State/Slices/SelectedCareersClientSlice";
import DraggableTable from "../../../../App/Components/Table/DraggableTable";
import { updateFeatureJobOrder } from "../../../FeaturedJobsPage/FeaturedJobsService";

function FeaturedGroupDetailed() {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "50%",
      marginBottom: "50px",
      [theme.breakpoints.down("md")]: {
        width: "100%",
      },
    },
    cardContainer: {
      [theme.breakpoints.down("md")]: {
        width: "100%",
        overflowY: "scroll",
      },
      display: "flex",
      flexDirection: "column",
      marginBottom: "20px",
      width: "50%",
    },
    sensitiveSection: {
      width: "100%",
      height: "25%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      paddingTop: "20px",
    },
    sensitiveButton: {
      [theme.breakpoints.down("md")]: {
        maxWidth: "none",
        width: "100%",
      },
      width: "200px",
      color: "white",
      backgroundColor: theme.palette.error.main,
    },
    error: {
      color: theme.palette.error.main,
    },
  }));

  const classes = useStyles();

  let location = useLocation();
  const [showSignifier, setShowSignifier] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const selectCareersClient = useSelector(selectCareersClientValue);
  const [tableData, setTableData] = useState(location.state.featureAds);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [clientId, setClientId] = useState("");
  const [groupId, setGroupId] = useState("");
  const [processing, setProcessing] = useState(false);

  const columns = [
    { label: "Title", propName: "title" },
    { label: "Ref. Number", propName: "referenceNumber" },
    { label: "Delete", propName: "" },
    { label: "", propName: "" },
  ];

  function deleteGroup() {
    callAPI(
      deleteFeaturedGroup(groupId),
      "Group Deleted",
      setShowSignifier,
      setResponseMessage,
      setShowError,
      setProcessing
    );
  }

  useEffect(() => {
    // update only when the user makes a change
    if (tableData.length > 0) {
      var update = [...tableData];
      update.forEach((group, index) => (group.order = index + 1));
      updateFeatureJobOrder(clientId, groupId, update);
    }
  }, [tableData]);

  useEffect(() => {
    if (location.state !== null && location.state != undefined) {
      setGroupId(location.state.id);
      setClientId(location.state.clientId);
    }
  }, []);

  if (location.state === null || location.state === undefined) {
    return <Redirect to="/featuredgroups" />;
  }

  if (selectCareersClient.id !== clientId && clientId !== "") {
    return <Redirect to="/featuredgroups" />;
  }

  return (
    <>
      <Signifier
        showSignifier={showSignifier}
        setShowSignifier={setShowSignifier}
        message={responseMessage}
        error={showError}
      />
      <div className="page-container">
        <Breadcrumb />
        <h1 className="page-title">
          {selectCareersClient.shortName} Featured Group Detailed
        </h1>
        <div className={classes.root}>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12}>
              <FormHelperText style={{ fontWeight: "bold", fontSize: "24px" }}>
                Featured Jobs
              </FormHelperText>
            </Grid>
            <Grid item xs={12} sm={12}>
              <Button
                style={{ marginBottom: "20px", marginRight: "10px" }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => setAddModal(!addModal)}
              >
                Add Jobs
              </Button>
            </Grid>
            <DraggableTable
              columns={columns}
              tableData={tableData}
              setTableData={setTableData}
              rowComponent={DetailedTableCell}
              loading={false}
            />
            <div className={classes.sensitiveSection}>
              <Grid
                item
                xs={12}
                sm={12}
                container
                justifyContent="space-between"
              >
                <Button
                  className={classes.sensitiveButton}
                  type="submit"
                  variant="contained"
                  color="secondary"
                  onClick={() => setDeleteModal(!deleteModal)}
                >
                  Delete Group
                </Button>
              </Grid>
            </div>
          </Grid>
        </div>
      </div>
      <Dialog open={addModal} onClose={() => setAddModal(false)}>
        <DetailedAddModal
          openModal={setAddModal}
          data={tableData}
          setData={setTableData}
          groupId={groupId}
          setShowSignifier={setShowSignifier}
          setResponseMessage={setResponseMessage}
          setShowError={setShowError}
          clientId={clientId}
        />
      </Dialog>
      <Dialog open={deleteModal} onClose={() => setDeleteModal(false)}>
        <ConfirmationModal
          question="Delete this group? This will also delete all featured jobs belonging to this group"
          func={() => deleteGroup()}
          closeModal={() => setDeleteModal(false)}
        />
      </Dialog>
    </>
  );
}

export default FeaturedGroupDetailed;
